var $32bc609604120001$exports = {};
$32bc609604120001$exports = {
    "removeButtonLabel": `Eliminar`,
    "removeDescription": `Prima Delete para eliminar a tag.`
};


export {$32bc609604120001$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
